var _style, _circle, _path, _path2, _path3, _g, _g2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#496E2D;}\n\t.st2{fill:#A2001D;}\n\t.st3{fill:#000000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,0C154.5,0,66.8,59.1,25.4,144.7h461.2C445.2,59.1,357.5,0,256,0L256,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c-101.5,0-189.2-59.1-230.6-144.7h461.2C445.2,452.9,357.5,512,256,512L256,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M499.9,178.1H12.1C4.2,202.7,0,228.8,0,256s4.2,53.3,12.1,77.9h487.8c7.8-24.6,12.1-50.7,12.1-77.9 S507.8,202.7,499.9,178.1L499.9,178.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.7,118.3l-30.3-14L256,216.2l-49.4-111.9l-30.3,14L237.6,256l-61.3,137.7l30.3,14L256,295.8l49.4,111.9 l30.3-14L274.4,256L335.7,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.6,131.5c-11.7-12.8-20.6-20.2-20.6-20.2s-8.9,7.4-20.6,20.2v249c11.7,12.8,20.6,20.2,20.6,20.2 s8.9-7.4,20.6-20.2V131.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,179.2v153.5c12.4,22,27.6,40,39,51.9V127.3C227.9,139.3,212.7,157.3,200.3,179.2L200.3,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.7,179.2c-12.4-22-27.6-40-39-51.9v257.4c11.4-11.9,26.6-30,39-51.9V179.2z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.7,179.2v153.5c12.6-22.2,22.3-48.6,22.3-76.8S324.2,201.5,311.7,179.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.3,179.2v153.5c-12.6-22.2-22.3-48.6-22.3-76.8S187.8,201.5,200.3,179.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.3149030a92d04a3a1ed07ad3af9c165c.svg";
export { ForwardRef as ReactComponent };